module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.448c34a56d699c29117adc64c43affeb.woff2";